
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GpsTrackerDto } from '../../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DutyStore from '../../../../stores/DutyStore';

@Component({
  name: 'TabTrigger',
  components: {
    vSelect,
  },
})
export default class TabTrigger extends Vue {
  readonly dutyStore = new DutyStore();

  @Prop({ required: true })
  tracker!: GpsTrackerDto;
  @Prop({ default: false })
  disabled!: boolean;

  get triggerDistanceTraveledDutySetPointMinutes(): number {
    return this.tracker.triggerDistanceTraveledDutySetPointSeconds / 60;
  }

  set triggerDistanceTraveledDutySetPointMinutes(val: number) {
    this.tracker.triggerDistanceTraveledDutySetPointSeconds = val * 60;
  }

  get triggerDistanceTraveledDutyKilometers(): number {
    return this.tracker.triggerDistanceTraveledDutyMeters / 1000;
  }

  set triggerDistanceTraveledDutyKilometers(val: number) {
    this.tracker.triggerDistanceTraveledDutyMeters = val * 1000;
  }

  get uid(): string {
    return (this as any)._uid;
  }

  async mounted(): Promise<void> {
    await this.dutyStore.loadIfAbsent();
  }
}
